export const EMDASH = '—' // it's like a dash, but longer
